import { NotImplementedDialog } from './components/dialogs/not-implemented-dialog';
import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
// Angular Material
import { MaterialModule } from '../app/material.module';

@NgModule({
    imports: [
        MaterialModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
  ],
    declarations: [
      NotImplementedDialog
    ],
    entryComponents: [
      NotImplementedDialog
        ], 
    exports: [
      NotImplementedDialog
    ]
})
  
export class NotImplementedDialogModule {}
